import { render, staticRenderFns } from "./RoundBtn.vue?vue&type=template&id=b8abb774&scoped=true&"
import script from "./RoundBtn.vue?vue&type=script&lang=js&"
export * from "./RoundBtn.vue?vue&type=script&lang=js&"
import style0 from "./RoundBtn.vue?vue&type=style&index=0&id=b8abb774&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8abb774",
  null
  
)

export default component.exports